import haversine from "haversine-distance";
import type { Airport } from "@airhelp/react";
import { distanceRanges } from "../config";

export const calculateAirportDistance = (departureAirport: Airport, arrivalAirport: Airport) =>
  haversine(
    {
      latitude: departureAirport?.latitude,
      longitude: departureAirport?.longitude,
    },
    {
      latitude: arrivalAirport?.latitude,
      longitude: arrivalAirport?.longitude,
    }
  );

const calculateCompensationPerPassenger = (departureAirport: Airport, arrivalAirport: Airport) => {
  const distanceInMeters = calculateAirportDistance(departureAirport, arrivalAirport);
  const distance = Math.ceil(distanceInMeters / 1000);
  const compensationPerPassenger =
    distance <= distanceRanges[1].distance
      ? distanceRanges[0].compensation
      : distance <= distanceRanges[2].distance
      ? distanceRanges[1].compensation
      : distanceRanges[2].compensation;

  return compensationPerPassenger;
};

export const calculateCompensation = (
  departureAirport: Airport,
  arrivalAirport: Airport,
  numberOfPassengers: number
) => {
  const compensationPerPassenger = calculateCompensationPerPassenger(departureAirport, arrivalAirport);

  if (numberOfPassengers < 1 || !departureAirport || !arrivalAirport) return 0;

  return compensationPerPassenger * numberOfPassengers;
};
